import {invoice} from "../../../../app/services/dataTemplates"
import {auth, get, post, put, url} from "../../../../app/services/Backend/HttpRequest"

export default {
  namespaced: true,
  state() {
    return {
      loaded: false,
      data: invoice(),
    }
  },
  mutations: {
    truncate(state) {
      state.loaded = false

      state.data = invoice()
    },

    fill(state, data) {
      state.loaded = true

      state.data = data
    },
  },
  actions: {
    fetch({rootState, commit}, uuid) {

      const input = {
        url: url(`auth/invoice/${uuid}`),
        headers: auth(rootState)
      }

      return get(input).then(response => commit('fill', response.data))
    },
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/earnings/invoices/invoice.js